import { useEffect, useRef, useState } from 'react';

export default function AirlineCarousel() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isPaused, setIsPaused] = useState(false);

  const airlines = [
    { name: 'British Airways', logo: 'https://public.readdy.ai/ai/img_res/39b7a6ccd461323af7c35cd17a56de40.jpg' },
    { name: 'Emirates', logo: 'https://readdy.ai/api/search-image?query=Emirates%20airline%20logo%20official%20brand%20white%20background%20high%20quality%20vector%20style%20clean%20professional&width=200&height=100&seq=airline-emirates-001&orientation=landscape' },
    { name: 'Qatar Airways', logo: 'https://readdy.ai/api/search-image?query=Qatar%20Airways%20airline%20logo%20official%20brand%20white%20background%20high%20quality%20vector%20style%20clean%20professional&width=200&height=100&seq=airline-qatar-001&orientation=landscape' },
    { name: 'Turkish Airlines', logo: 'https://readdy.ai/api/search-image?query=Turkish%20Airlines%20airline%20logo%20official%20brand%20white%20background%20high%20quality%20vector%20style%20clean%20professional&width=200&height=100&seq=airline-turkish-001&orientation=landscape' },
    { name: 'Etihad Airways', logo: 'https://readdy.ai/api/search-image?query=Etihad%20Airways%20airline%20logo%20official%20brand%20white%20background%20high%20quality%20vector%20style%20clean%20professional&width=200&height=100&seq=airline-etihad-001&orientation=landscape' },
    { name: 'Saudi Arabian Airlines', logo: 'https://readdy.ai/api/search-image?query=Saudi%20Arabian%20Airlines%20Saudia%20airline%20logo%20official%20brand%20white%20background%20high%20quality%20vector%20style%20clean%20professional&width=200&height=100&seq=airline-saudia-001&orientation=landscape' },
    { name: 'PIA', logo: 'https://readdy.ai/api/search-image?query=Pakistan%20International%20Airlines%20PIA%20airline%20logo%20official%20brand%20white%20background%20high%20quality%20vector%20style%20clean%20professional&width=200&height=100&seq=airline-pia-001&orientation=landscape' },
    { name: 'Lufthansa', logo: 'https://readdy.ai/api/search-image?query=Lufthansa%20airline%20logo%20official%20brand%20white%20background%20high%20quality%20vector%20style%20clean%20professional&width=200&height=100&seq=airline-lufthansa-001&orientation=landscape' },
    { name: 'American Airlines', logo: 'https://readdy.ai/api/search-image?query=American%20Airlines%20airline%20logo%20official%20brand%20white%20background%20high%20quality%20vector%20style%20clean%20professional&width=200&height=100&seq=airline-american-001&orientation=landscape' },
    { name: 'Air India', logo: 'https://readdy.ai/api/search-image?query=Air%20India%20airline%20logo%20official%20brand%20white%20background%20high%20quality%20vector%20style%20clean%20professional&width=200&height=100&seq=airline-airindia-001&orientation=landscape' },
  ];

  // Duplicate airlines for seamless loop
  const duplicatedAirlines = [...airlines, ...airlines];

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer || isPaused) return;

    let scrollPosition = 0;
    const scrollSpeed = 1;

    const scroll = () => {
      if (!isPaused) {
        scrollPosition += scrollSpeed;
        
        // Reset position when halfway through (seamless loop)
        if (scrollPosition >= scrollContainer.scrollWidth / 2) {
          scrollPosition = 0;
        }
        
        scrollContainer.scrollLeft = scrollPosition;
      }
      requestAnimationFrame(scroll);
    };

    const animationId = requestAnimationFrame(scroll);

    return () => cancelAnimationFrame(animationId);
  }, [isPaused]);

  return (
    <section className="py-16 bg-white border-y border-gray-100">
      <div className="max-w-7xl mx-auto px-6 mb-8">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>
          Our Airline Partners
        </h2>
        <p className="text-center text-gray-600 mt-3">We work with leading airlines worldwide to bring you the best fares</p>
      </div>

      <div
        ref={scrollRef}
        className="overflow-hidden"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div className="flex gap-12 items-center" style={{ width: 'max-content' }}>
          {duplicatedAirlines.map((airline, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-48 h-24 bg-white rounded-lg flex items-center justify-center p-4 border border-gray-100 hover:shadow-lg transition-shadow duration-300"
            >
              <img
                src={airline.logo}
                alt={airline.name}
                className="max-w-full max-h-full object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
